import { useTheme } from "../ThemeContext";
import api_requests from "../resources/api_requests";
import constant from "../resources/constant";
import utils from "../resources/utils";
import {
  HIDE_LOADER,
  SET_RECIVER_DETAILS,
  SET_SENDER_DETAILS,
  SHOW_LOADER,
  NEW_ADDRESS_DETAILS,
  SET_USER_DETAILS,
  SET_BUSINESS_LIST,
  SET_SELECTED_BUSINESS,
  LOGIN_FAILED,
} from "./actionConstants";

export const get_user_details = (updateTheme) => async (dispatch) => {
  const auth_token = utils._retrieveData(constant.AUTH_TOKEN);
  const type_of_owner = utils._retrieveData(constant.TYPE_OF_OWNER);
  const selected_business = utils._retrieveData(constant.SELECTED_BUSINESS);
  const selected_business_id = utils._retrieveData(
    constant.SELECTED_BUSINESS_ID,
  );
  try {
    if (!auth_token) {
      dispatch(login_failed());
      return Promise.resolve();
    }
    utils.setRequestAuthHeader(auth_token, type_of_owner);
    // utils.setRequestAuthHeaderBusinessId(owner_id, parent_id);
    // const business_accounts = (await api_requests.get_business_accounts()).data;
    const app_configs = (
      await api_requests.get_common_configs(selected_business.business_id)
    ).data;
    const businessConfig = app_configs?.business_configs[selected_business_id];
    dispatch(set_user_details(businessConfig));

    updateTheme(
      app_configs?.business_configs[selected_business_id]?.whitelabeling,
    );
    return Promise.resolve();
  } catch (err) {
    dispatch(login_failed());
    return Promise.reject(err);
  }
};
export const set_sender_details = (data) => ({
  type: SET_SENDER_DETAILS,
  data,
});

export const set_reciver_details = (data) => ({
  type: SET_RECIVER_DETAILS,
  data,
});

export const show_loader = () => async (dispatch) => {
  dispatch({ type: SHOW_LOADER });
};

export const hide_loader = () => async (dispatch) => {
  dispatch({ type: HIDE_LOADER });
};

export const set_new_address_details = (data) => ({
  type: NEW_ADDRESS_DETAILS,
  data,
});

export const set_user_details = (data) => ({
  type: SET_USER_DETAILS,
  data,
});

export const set_buiness_list = (data) => ({
  type: SET_BUSINESS_LIST,
  data,
});

export const set_selected_business = (data) => ({
  type: SET_SELECTED_BUSINESS,
  data,
});

export const login_failed = () => {
  utils.logout();
  return { type: LOGIN_FAILED };
};
